import server from './http'
import { Message } from 'element-ui'

const checkResponse = (request) => request.then(res => {
    if (res && Number(res.code) === 500) {
        const message = res.msg || res.message || '请求失败'
        Message.error(message)
        const error = new Error(message)
        error.msg = message
        error.scheduleMessageShown = true
        throw error
    }
    return res
})

const scheduleApi = {
    scheduleDepartmentList: (param) => checkResponse(server.post('/workforce/departmentList', param)), // 获取部门列表
    scheduleStaffList: (param) => checkResponse(server.post('/workforce/staffList', param)), // 获取员工列表
    scheduleWorkforceList: (param) => checkResponse(server.post('/workforce/workforceList', param)), // 获取排班列表
    saveProjectWorkforce: (param) => checkResponse(server.post('/workforce/saveProjectWorkforce', param)), // 新增/编辑排班规则
    deleteProjectWorkforce: (param) => checkResponse(server.post('/workforce/deleteProjectWorkforce', param)), // 删除排班规则
    saveProjectClockAddress: (param) => checkResponse(server.post('/workforce/saveProjectClockAddress', param)), // 新增/编辑打卡地址
    deleteProjectClockAddress: (param) => checkResponse(server.post('/workforce/deleteProjectClockAddress', param)), // 删除打卡地址
    saveProjectWorkforceClock: (param) => checkResponse(server.post('/workforce/saveProjectWorkforceClock', param)), // 设为打卡地点
    saveProjectWorkforceSchedule: (param) => checkResponse(server.post('/workforce/saveProjectWorkforceSchedule', param)), // 新增/编辑排班班次
    deleteProjectWorkforceSchedule: (param) => checkResponse(server.post('/workforce/deleteProjectWorkforceSchedule', param)), // 删除班次
    saveWorkforce: (param) => checkResponse(server.post('/workforce/saveWorkforce', param, { timeout: 60000 })), // 保存排班/生成排班
    getWorkforceDetail: (param) => checkResponse(server.post('/workforce/workforceDetail', param)), // 查看排班详情
    modifyWorkforceMember: (param) => checkResponse(server.post('/workforce/modifyWorkforceMember', param)), // 调整排班
    workforceMemberList: (param) => checkResponse(server.post('/workforce/workforceMemberList', param)), // 获取排班成员列表
    deleteProjectWorkforceMember: (param) => checkResponse(server.post('/workforce/deleteProjectWorkforceMember', param)), // 删除排班人员
    workforceMemberExport: (param) => checkResponse(server.post('/workforce/workforceMemberList', param, {
        responseType: 'blob',
        timeout: 60000,
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    })), // 导出排班
    importProjectClockAddress: (param) => checkResponse(server.post('/workforce/importProjectClockAddress', param)), // 导入打卡地址
    saveBatchProjectClockAddress: (param) => checkResponse(server.post('/workforce/saveBatchProjectClockAddress', param)), // 批量保存打卡地址
}

export default scheduleApi
